import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { translationProvider } from '@ui/nls/translations/translate.directive';

@Component({
    selector: 'lib-print-details',
    templateUrl: './print-details.component.html',
    styleUrls: ['./print-details.component.scss'],
    providers: [translationProvider('productFront')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintDetailsComponent implements OnInit {
  @Input() printFormatId;
  @Input() printPaperId;
  constructor() {}

  ngOnInit(): void {}
}
